"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Renderables_1 = require("../Renderables");
/**
 * Implementation of the 'break' markup element.
 * A br HTML element is created.
 *
 * @see {@link IRenderable}
 */
var Break = /** @class */ (function () {
    function Break(spec) {
        this.spec = spec;
    }
    /**
     * @inheritDoc
     */
    Break.prototype.render = function (renderer, isNested) {
        var br = document.createElement('br');
        if (this.spec.id !== undefined) {
            br.id = this.spec.id;
        }
        if (this.spec.class !== undefined) {
            this.spec.class.split(" ").forEach(function (e) { return br.classList.add(e); });
        }
        return br;
    };
    return Break;
}());
exports.Break = Break;
Renderables_1.default.register("break", Break);
